<template>
    <svg
        class="donut"
        xmlns="http://www.w3.org/2000/svg"
        :width="width + strokeWidth"
        :height="height + strokeWidth"
        :viewbox="`0 0 ${width + strokeWidth} ${height + strokeWidth}`">
        <circle
            class="donut__background"
            :cx="cx"
            :cy="cy"
            :r="radius"
            fill="transparent"
            :stroke-width="strokeWidth"
            :stroke-dasharray="circumference" ></circle>
        <circle
            v-if="value > 0"
            class="donut__fill"
            :cx="cx"
            :cy="cy"
            :r="radius"
            fill="transparent"
            :stroke="color"
            :stroke-width="strokeWidth"
            :stroke-dasharray="circumference"
            :stroke-dashoffset="strokeDashOffset"
            stroke-linecap="round"></circle>
    </svg>
</template>

<script>

import Vue from "vue";

export default {
    name: "Donut",
    components: {
    },
    props: {
        radius: {
            type: Number,
            required: false,
            default: 64
        },
        cx: {
            type: String,
            required: false,
            default: "50%"
        },
        cy: {
            type: String,
            required: false,
            default: "50%"
        },
        strokeWidth: {
            type: Number,
            required: false,
            default: 11
        },
        width: {
            type: Number,
            required: false,
            default: 128
        },
        height: {
            type: Number,
            required: false,
            default: 128
        },
        value: {
            type: Number,
            required: true
        },
        color: {
            type: String,
            required: false,
            default: "#9a6fe3"
        }
    },

    data() {
        return {
            strokeDashOffset: 400
        };
    },

    computed: {
        circumference() {
            return 2 * Math.PI * this.radius;
        },
    },

    mounted() {
        Vue.nextTick(() => {
            // Check if element is visible using IntersectionObserver
            // Should probably be polyfilled (https://caniuse.com/#search=IntersectionObserver)
            if ("IntersectionObserver" in window) {
                let lazyBackgroundObserver = new IntersectionObserver((entries, observer) => {
                    const entry = entries[0];

                    if (entry.isIntersecting) {
                        const strokeDiff = ((this.value / 100) * this.circumference);

                        this.strokeDashOffset = this.circumference - strokeDiff;
                    }
                }, {
                    threshold: 0.05,
                });

                // Increase POLL INTERVAL for polyfill
                // Fix issue on IOS Safari with intersection Observer not working only looking for dom-change and scroll
                // https://github.com/w3c/IntersectionObserver/tree/master/polyfill#configuring-the-polyfill
                lazyBackgroundObserver.POLL_INTERVAL = 100;

                lazyBackgroundObserver.observe(this.$el);
            }
        });
    },

    destroyed() {
    },


    methods: {
    },
};
</script>